import './ccf-button.module.scss';
import { Button, ButtonProps, PropTypes, Theme } from '@mui/material';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';
import '../style/Ccf.Palette.Module';
// interface color extends PropTypes.Color

export interface CcfButtonProps extends Omit<ButtonProps, ''> {
  primary?: boolean;
}

/**
 * Component used to display Button
 * @param param0 - CcfButtonProps
 * @example <CcfButton />
 * @returns  Button
 */
export function CcfButton({ children, primary, ...rest }: CcfButtonProps) {
  const useStyles = makeStyles(({ palette }: Theme) =>
    /**
     * Color styles for contained (aka raised) buttons
     * @see https://github.com/mui-org/material-ui/blob/8995f085904eb55bcb5861fb6d8a32fbd38d72eb/packages/material-ui/src/Button/Button.js#L131-L141
     */
    createStyles({
      buttonColorState: {
        color: primary ? palette?.background?.paper : palette?.text.secondary,
        //border: primary ? 'none' : '1px solid #dae2e8',
        backgroundColor: primary
          ? palette?.primary?.main
          : palette?.background?.paper,
        boxShadow: `0px 2px 0px ${
          primary ? palette?.primary?.dark : '#dae2e8'
        }`,
        '&:hover': {
          backgroundColor: primary
            ? palette?.primary?.dark
            : palette?.background?.paper,
          border: primary ? 'none' : '1px solid #dae2e8',
          boxShadow: `0px 2px 0px ${
            primary ? palette?.primary?.dark : '#dae2e8'
          }`,
          // Reset on touch devices, it doesn't add specificity
          '@media (hover: none)': {
            backgroundColor: primary ? '#ecf5fa' : palette?.background?.paper,
          },
        },
        '&:disabled': {
          backgroundColor: '#f8fafb',
          borderColor: '#dae2e8',
          boxShadow: '0px 2px 0px #dae2e8',
          color:'#0000001a',
        },
      },
      // This is required for the '&$disabled' selector to work
      disabled: {},
    })
  );
  const classes = useStyles();
  return (
    <Button classes={{ root: classes.buttonColorState }} {...rest}>
      {children}
    </Button>
  );
}

export default CcfButton;
